import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { LucideCircleAlert } from '@lucide/angular';

/** Validation message with icon — status is never conveyed by color alone. */
@Component({
  selector: 'ds-field-error',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
  template: `
    <p class="ds-field__error" [id]="errorId()">
      <ng-container
        [ngComponentOutlet]="icon"
        [ngComponentOutletInputs]="{ size: 20, strokeWidth: 2.25 }"
      />
      <span><ng-content /></span>
    </p>
  `,
})
export class FieldErrorComponent {
  errorId = input.required<string>();

  protected readonly icon = LucideCircleAlert;
}
